import React, { useState, useEffect } from 'react';
import { FaEdit, FaListUl, FaPlus, FaFilter, FaArrowLeft } from 'react-icons/fa';
import axios from '../../../config/axios';
import Swal from 'sweetalert2';
import MenusModal from './modals/Menus';
import TipoAcessoModal from './modals/TipoAcesso';
import Paginacao from '../../../components/utils/paginacao';
import { useNavigate } from 'react-router-dom';

const TiposAcesso = () => {
  const navigate = useNavigate();
  const [showMenusModal, setShowMenusModal] = useState(false);
  const [selectedTipo, setSelectedTipo] = useState(null);
  const [showTipoModal, setShowTipoModal] = useState(false);
  const [tipos, setTipos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filtroNome, setFiltroNome] = useState('');

  const handleOpenMenus = (tipo) => {
    setSelectedTipo(tipo);
    setShowMenusModal(true);
  };

  const handleCloseMenus = () => {
    setShowMenusModal(false);
    setSelectedTipo(null);
  };

  const handleNovoTipo = () => {
    setSelectedTipo(null);
    setShowTipoModal(true);
  };

  const handleEditarTipo = (tipo) => {
    setSelectedTipo(tipo);
    setShowTipoModal(true);
  };

  const handleCloseTipo = () => {
    setShowTipoModal(false);
    setSelectedTipo(null);
  };

  const fetchTipos = async (page = 1) => {
    try {
      Swal.fire({
        title: "Carregando...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await axios.get('/tipos-de-acesso', {
        params: {
          page,
          limit: 10,
          nome: filtroNome
        }
      });
      
      setTipos(response.data.records || []);
      setCurrentPage(response.data.paginaAtual || 1);
      setTotalPages(response.data.totalPaginas || 1);
      setTotalRecords(response.data.totalRegistros || 0);
      Swal.close();
    } catch (error) {
      Swal.close();
      Swal.fire('Erro!', 'Erro ao carregar tipos de acesso', 'error');
    }
  };

  const handleSaveTipo = async (dadosTipo) => {
    try {
      if (selectedTipo && selectedTipo.id) {
        await axios.put(`/tipos-de-acesso/${selectedTipo.id}`, dadosTipo);
        Swal.fire('Sucesso!', 'Tipo de acesso atualizado com sucesso', 'success');
      } else {
        await axios.post('/tipos-de-acesso', dadosTipo);
        Swal.fire('Sucesso!', 'Tipo de acesso criado com sucesso', 'success');
      }
      fetchTipos(currentPage);
      handleCloseTipo();
    } catch (error) {
      Swal.fire('Erro!', 'Erro ao salvar tipo de acesso', 'error');
    }
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchTipos(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
  };

  useEffect(() => {
    fetchTipos();
  }, []);

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <button
                  className="btn btn-outline-secondary me-3"
                  onClick={() => navigate('/configuracoes')}
                  title="Voltar para Configurações"
                >
                  <FaArrowLeft />
                </button>
                <h4 className="fw-bold mb-0">Tipos de Acesso</h4>
              </div>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-8 col-12">
              <button className="btn btn-outline-primary" onClick={handleNovoTipo}>
                <FaPlus /> Novo Tipo
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-4 col-md-6 col-12">
              <label className="form-label fw-bold">Nome do Tipo de Acesso</label>
              <input
                type="text"
                placeholder="Digite o nome do tipo de acesso"
                autoComplete="off"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-8 col-md-6 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead className="table-custom-primary">
                    <tr>
                      <th>Nome</th>
                      <th className="text-center" style={{ width: '160px' }}>Aparece na agenda</th>
                      <th className="text-center" style={{ width: '140px' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tipos.length === 0 ? (
                      <tr>
                        <td colSpan="3" className="text-center">Nenhum tipo de acesso encontrado</td>
                      </tr>
                    ) : (
                      tipos.map((tipo) => (
                        <tr key={tipo.id}>
                          <td className="text-nowrap">{tipo.nome}</td>
                          <td className="text-nowrap text-center">{tipo.aparece_na_agenda ? 'Sim' : 'Não'}</td>
                          <td className="text-nowrap text-center">
                            <button
                              className="btn btn-custom-secondary btn-sm"
                              onClick={() => handleEditarTipo(tipo)}
                              title="Editar"
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="btn btn-custom-secondary btn-sm ms-3"
                              onClick={() => handleOpenMenus(tipo)}
                              title="Menus"
                            >
                              <FaListUl />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              
            <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="mb-3">
                    <span>
                        Total de registros: <strong>{totalRecords}</strong>
                    </span>
                </div>
                <Paginacao
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(page) => fetchTipos(page)}
                />
            </div>
            </div>
          </div>
        </div>
      </div>

      {showMenusModal && (
        <MenusModal tipo={selectedTipo} onClose={handleCloseMenus} />
      )}
      {showTipoModal && (
        <TipoAcessoModal tipo={selectedTipo} onClose={handleCloseTipo} onSave={handleSaveTipo} />
      )}
    </div>
  );
};

export default TiposAcesso;


